import UserPasswordChangeParams from "../../../../../common/services/user/password-change/user-password-change-params";
import AppHeaderUserChangePasswordFormData from "../types/app-header-user-change-password-form-data";

const createChangePasswordRequest = (
  formData: AppHeaderUserChangePasswordFormData,
): UserPasswordChangeParams => {
  return {
    oldPassword: formData.currentPassword,
    newPassword: formData.newPassword,
  };
};

const appHeaderUserChangePasswordFactory = {
  createChangePasswordRequest,
};

export default appHeaderUserChangePasswordFactory;
